import { Vue } from 'vue-class-component';
import { Provide, Options, Inject } from 'vue-property-decorator';
import UserDefine from '../../../assets/config/user-define.json';
import { RouteN } from '@/constants/route-name';
import { Prop, Watch } from 'vue-property-decorator';
import { EventEmitter } from 'events';
import { AppInsights } from '@/appInsights';
import store from '@/store';

@Options({})
export default class ApplicationMenuComponent extends Vue {

  @Prop({required: true})
  public show!: boolean;

  @Inject({ from: 'eventController', default: new EventEmitter })
  private eventCtrl!: EventEmitter;

  private ai = new AppInsights;

  private logout() {
    this.$router.push({name: RouteN.CMP.LogoutPage.n});
  }

  private goToFAQ() {
    window.open(UserDefine[0].faq_url, '_blank'); 
  }

  get RouteN(): any {
    return RouteN;
  }
}
